import type { createApi } from "@reduxjs/toolkit/query/react";

export type ApiEndpointBuilder = Parameters<
  Parameters<typeof createApi>[0]["endpoints"]
>[0];

/**
 * Keeps endpoint query arguments absent when a caller has no filters.
 */
export const optionalQueryParams = <T>(params: T | void): T | undefined =>
  typeof params === "undefined" ? undefined : params;

/**
 * Keeps mutation payloads object-shaped for the Axios-style base query.
 */
export const optionalMutationBody = <T extends object>(
  body: T | void,
): T | Record<string, never> => (typeof body === "undefined" ? {} : body);

/**
 * Builds the shared list/entity cache tags used by collection endpoints.
 */
export function providesList<
  R extends Array<{ id: string | number }>,
  T extends string,
>(resultsWithIds: R | undefined, tagType: T) {
  return resultsWithIds
    ? [
        { type: tagType, id: "LIST" },
        ...resultsWithIds.map(({ id }) => ({ type: tagType, id })),
      ]
    : [{ type: tagType, id: "LIST" }];
}
